// Modern JSX transform - React import not needed
import { memo } from 'react'

/**
 * SpotModeCrosshair - Centered pulsing crosshair overlay
 * Guides user to tap/drag the map before dropping their first pin.
 * Hidden once a location has been set.
 *
 * @component
 * @idempotent @atomic
 */
const SpotModeCrosshair = memo(function SpotModeCrosshair({ visible }) {
  if (!visible) return null

  return (
    <div className="spot-crosshair" aria-hidden="true">
      <svg
        className="spot-crosshair-svg"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Horizontal arm */}
        <line x1="0" y1="24" x2="18" y2="24" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="30" y1="24" x2="48" y2="24" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        {/* Vertical arm */}
        <line x1="24" y1="0" x2="24" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="24" y1="30" x2="24" y2="48" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        {/* Center circle */}
        <circle cx="24" cy="24" r="4" stroke="currentColor" strokeWidth="2" fill="none" />
      </svg>
    </div>
  )
})

export default SpotModeCrosshair
